import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["Alarms"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getV2Alarms: build.query<GetV2AlarmsApiResponse, GetV2AlarmsApiArg>({
        query: (queryArg) => ({
          url: `/v2/Alarms`,
          params: {
            AccountIds: queryArg.accountIds,
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
            alarmState: queryArg.alarmState,
            alarmType: queryArg.alarmType,
          },
        }),
        providesTags: ["Alarms"],
      }),
      getV2AlarmsById: build.query<
        GetV2AlarmsByIdApiResponse,
        GetV2AlarmsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Alarms/${queryArg.id}`,
          params: {
            AccountIds: queryArg.accountIds,
          },
        }),
        providesTags: ["Alarms"],
      }),
      putV2AlarmsByIdState: build.mutation<
        PutV2AlarmsByIdStateApiResponse,
        PutV2AlarmsByIdStateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Alarms/${queryArg.id}/State`,
          method: "PUT",
          body: queryArg.alarmState,
          params: {
            AccountIds: queryArg.accountIds,
          },
        }),
        invalidatesTags: ["Alarms"],
      }),
      getV2AlarmsFeed: build.query<
        GetV2AlarmsFeedApiResponse,
        GetV2AlarmsFeedApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Alarms/Feed`,
          params: {
            AccountIds: queryArg.accountIds,
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
            createdStart: queryArg.createdStart,
            createdEnd: queryArg.createdEnd,
            alarmState: queryArg.alarmState,
            alarmType: queryArg.alarmType,
          },
        }),
        providesTags: ["Alarms"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type GetV2AlarmsApiResponse = /** status 200 OK */ GetAlarmDto[];
export type GetV2AlarmsApiArg = {
  accountIds?: number[];
  orderBy?: "Created";
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
  alarmState?: AlarmState;
  alarmType?: AlarmTypes;
};
export type GetV2AlarmsByIdApiResponse = /** status 200 OK */ GetAlarmDto;
export type GetV2AlarmsByIdApiArg = {
  accountIds?: number[];
  id: number;
};
export type PutV2AlarmsByIdStateApiResponse = unknown;
export type PutV2AlarmsByIdStateApiArg = {
  accountIds?: number[];
  id: number;
  alarmState: AlarmState;
};
export type GetV2AlarmsFeedApiResponse = /** status 200 OK */ GetAlarmDto[];
export type GetV2AlarmsFeedApiArg = {
  accountIds?: number[];
  orderBy?: "Created";
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
  createdStart?: string;
  createdEnd?: string;
  alarmState?: AlarmState;
  alarmType?: AlarmTypes;
};
export type Severity =
  | "Information"
  | "Trivial"
  | "Minor"
  | "Medium"
  | "Major"
  | "Critical";
export type AlarmState =
  | "Unresolved"
  | "Reject"
  | "Solved"
  | "Reset"
  | "AutoResolved"
  | "FalseAlarm"
  | "None";
export type StateHistoryDto = {
  timestamp?: string;
  state?: string | null;
};
export type IntAssociation = {
  id?: number;
  name?: string | null;
};
export type GuidAssociation = {
  id?: string;
  name?: string | null;
};
export type DataStreamAssociation = {
  unitId?: number;
  unitTypeInputId?: number | null;
  dataType?: string | null;
};
export type AssociationsDto = {
  units?: IntAssociation[] | null;
  buildings?: IntAssociation[] | null;
  jobSubscriptions?: IntAssociation[] | null;
  sensors?: IntAssociation[] | null;
  gateways?: IntAssociation[] | null;
  energyGroups?: IntAssociation[] | null;
  energyInitiatives?: IntAssociation[] | null;
  energyTreeNodes?: GuidAssociation[] | null;
  dataStreams?: DataStreamAssociation[] | null;
};
export type GetAlarmDto = {
  alarmId?: number;
  accountId?: number;
  alarmType?: string | null;
  dataFrom?: string | null;
  dataTo?: string | null;
  alarmSubtype?: string | null;
  severity?: Severity;
  title?: string | null;
  message?: string | null;
  metaData?: string | null;
  details?: string | null;
  state?: AlarmState;
  created?: string;
  stateChanged?: string | null;
  stateHistory?: StateHistoryDto[] | null;
  associations?: AssociationsDto;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type AlarmTypes =
  | "TimeBetweenConsumption"
  | "ConsumptionLevel"
  | "SeepLeakage"
  | "SensorDown"
  | "ActivityTimer"
  | "ExternalSensorDown"
  | "ThresholdLimit"
  | "FastSensorDown"
  | "BurstLeakage"
  | "TemperatureDeviation"
  | "HeatingSystem"
  | "VentilationSystem"
  | "CoolingSystem"
  | "BillingMeter"
  | "PowerDisaggregation"
  | "LowBattery"
  | "ElectricitySystem"
  | "PEOOperations"
  | "EnergyXOperations"
  | "PortfolioOperations"
  | "WaterSystem"
  | "UsageOverTime"
  | "QualityOfServiceDataStream";
export const {
  useGetV2AlarmsQuery,
  useGetV2AlarmsByIdQuery,
  usePutV2AlarmsByIdStateMutation,
  useGetV2AlarmsFeedQuery,
} = injectedRtkApi;
